import { render, staticRenderFns } from "./ListaPostagemCalendarioMidias.vue?vue&type=template&id=69b047e4&scoped=true"
import script from "./ListaPostagemCalendarioMidias.vue?vue&type=script&lang=js"
export * from "./ListaPostagemCalendarioMidias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b047e4",
  null
  
)

export default component.exports